import { render } from "./childIndex.vue?vue&type=template&id=6798b882"
import script from "./childIndex.vue?vue&type=script&lang=js"
export * from "./childIndex.vue?vue&type=script&lang=js"

import exportComponent from "D:\\zhang\\项目\\经皮黄疸仪\\jaundiceweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__